/**
 * Home Page Content
 * 
 * Content specific to the home/landing page including hero, CTA, and testimonials.
 */

import { BilingualText } from '@/types';

/**
 * Home page content
 */
export const homeContent = {
  hero: {
    headline: {
      line1: {
        en: "AI Fashion Prompts",
        es: "Prompts de Moda con IA",
      },
      line2: {
        en: "That Actually Look Editorial",
        es: "Con Calidad Editorial Real",
      },
    },
    subtitle: {
      en: "Ready-made prompt systems for generating campaign-quality fashion imagery. No studio. No photographer. Just your AI tool and our CHIMERA™ prompt architecture.",
      es: "Sistemas de prompts listos para generar imágenes de moda con calidad de campaña. Sin estudio. Sin fotógrafo. Solo tu herramienta de IA y nuestra arquitectura de prompts CHIMERA™.",
    },
    buttons: {
      browse: {
        en: "See the Prompt Collections — Starting from $13",
        es: "Ver los Packs de Prompts — Desde $13",
      },
      learnMore: {
        en: "How It Works",
        es: "Cómo Funciona",
      },
    },
    scrollIndicator: {
      en: "Scroll",
      es: "Desliza",
    },
  },
  cta: {
    title: {
      en: "Ready to Create?",
      es: "¿Listo para Crear?",
    },
    subtitle: {
      en: "Get instant access to professional fashion prompts",
      es: "Obtén acceso instantáneo a prompts profesionales de moda",
    },
  },
};

/**
 * Testimonials section content
 */
export const testimonialsContent = {
  title: {
    en: "What Creators Are Saying",
    es: "Lo Que Dicen Los Creadores",
  },
  subtitle: {
    en: "Real feedback from creators using our prompts.",
    es: "Comentarios reales de creadores que usan nuestros prompts.",
  },
};

/**
 * Hero showcase cards content (floating cards in hero section)
 */
export const heroShowcaseCards = {
  card1: {
    icon: "📷",
    title: { en: "Includes: lighting + camera + styling + negative prompts", es: "Incluye: iluminación + cámara + estilismo + prompts negativos" },
    subtitle: { en: "", es: "" },
  },
  card2: {
    icon: "⚡",
    title: { en: "Instant download, straight to your inbox", es: "Descarga instantánea, directo a tu bandeja de entrada" },
    subtitle: { en: "", es: "" },
  },
  card3: {
    icon: "🛠️",
    title: { en: "Works with all major photo generation tools", es: "Funciona con todas las herramientas principales de generación de fotos" },
    subtitle: { en: "", es: "" },
  },
};

/**
 * Mobile CTA bar content
 */
export const mobileCTAContent = {
  browseCollections: {
    en: "Browse Collections",
    es: "Ver Colecciones",
  },
  addToCart: {
    en: "Add to Cart",
    es: "Añadir",
  },
};
